module.exports = __webpack_public_path__ + "static/media/hot_zghgq.7fccf1d0.png";